import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { setActiveUser } from '../redux/features/activeUser/activeUser';
import { setShowVerifyFA, setSuggestFA } from '../redux/slices/verifyFASlice';
import { apiRegistry } from '../redux/api-register';
import { useLogoutMutation } from '../redux/features/auth/authApi';
import { useAuth } from './use-auth';
import { AuthProvider } from '../utilities/enums';

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data } = useAuth();
  const [logoutApi, { isLoading }] = useLogoutMutation();
  const token = localStorage.getItem('magjistraturaAppToken');

  const isMicrosoft = data?.authProvider === AuthProvider.MICROSOFT;

  const handleSignOut = () => {
    navigate('/login');

    setTimeout(() => {
      localStorage.clear();

      for (let index = 0; index < apiRegistry.length; index++) {
        const api = apiRegistry[index];
        dispatch(api.util.resetApiState());
      }

      dispatch(setActiveUser(''));
      dispatch(setSuggestFA(false));
      dispatch(setShowVerifyFA(false));
    }, 0);
  };

  const handleSignOutWithApi = () => {
    if (token && !pathname.includes('login')) {
      logoutApi()
        .unwrap()
        .then(res => {
          if (isMicrosoft) {
            window.location.href = res?.logoutUrl;
          } else {
            handleSignOut();
          }
        })
        .catch(() => {
          handleSignOut();
        });
    } else {
      handleSignOut();
    }
  };

  return { handleSignOut, handleSignOutWithApi, isLoading };
};
